"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Basket32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M1.595 3.182L.776 29.761h25.801l4.131-3.18-1.99-23.399H1.596zm-.431-.889h27.962c.231 0 .423.177.443.407l2.045 24.048a.444.444 0 01-.172.39l-4.443 3.42a.444.444 0 01-.271.092H.318a.444.444 0 01-.444-.458L.72 2.724a.444.444 0 01.444-.431z" }),
    react_1.default.createElement("path", { d: "M5.832 6.581c0 4.863 2.787 9.753 7.391 9.753 4.825 0 7.426-4.073 7.426-9.542a.444.444 0 00-.888 0c0 5.039-2.308 8.653-6.537 8.653-3.979 0-6.502-4.427-6.502-8.864a.444.444 0 00-.888 0zm19.147-3.823l1.305 27.468a.445.445 0 00.888-.042L25.867 2.716a.445.445 0 00-.888.042z" }))); };
var StyledBasket32 = styled_components_1.default(Basket32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledBasket32;
var templateObject_1;
//# sourceMappingURL=Basket32.js.map